import React from 'react';
import './HowItWorks.css';

const steps = [
  {
    label: '1',
    title: 'Describe Your Idea',
    text: 'Tell us what you want to build. A website? An app? Just give us the vision — no tech knowledge needed.',
  },
  {
    label: '2',
    title: 'AI Generates a Quotation',
    text: 'Our system instantly prepares a tailored quotation, with features, cost, and timeline.',
  },
  {
    label: '3',
    title: 'Review & Edit',
    text: 'You can edit the suggested features, adjust the scope, and finalize the project details.',
  },
  {
    label: '4',
    title: 'We Develop Your Project',
    text: 'Once approved, our team starts developing your idea using modern stacks and agile sprints.',
  },
  {
    label: '5',
    title: 'Launch & Grow',
    text: 'Your product is deployed and ready. We help with scaling, updates, and future versions too.',
  },
];

const HowItWorks = () => {
  return (
    <div className="hiw-container">
      <div className="hiw-hero">
        <h1 className="hiw-title">How It Works</h1>
        <p className="hiw-subtitle">
          From idea to deployment — our AI-powered system helps you launch your product faster than ever.
        </p>
      </div>

      <div className="hiw-steps">
        {steps.map((step, index) => (
          <div className="hiw-step" key={index}>
            <div className="hiw-number">{step.label}</div>
            <div className="hiw-content">
              <h3>{step.title}</h3>
              <p>{step.text}</p>
            </div>
          </div>
        ))}
      </div>

      <div className="hiw-cta">
        <h2>Get Started Instantly</h2>
        <p>Generate a custom project plan and get connected with our team.</p>
        <button onClick={() => window.open('/project_prompt', '_blank')}>
          Generate Quotation
        </button>
      </div>
    </div>
  );
};

export default HowItWorks;
